var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpPage",
    {
      attrs: {
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "JobSchedulerConfig",
        modalBindings: _vm.b_7315092382398562_modalBindings
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c("UcHeader", {
            attrs: {
              slot: "header",
              card: !_vm.modal,
              modal: _vm.modal,
              title: _vm.documentTitle
            },
            on: {
              close: function($event) {
                return _vm.evh_2248226175642056_close($event, {})
              }
            },
            slot: "header"
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcBody",
            { attrs: { card: !_vm.modal, modal: _vm.modal } },
            [
              _c(
                "ItpForm",
                {
                  attrs: {
                    name: _vm.formName,
                    readonly: _vm.resource.locked,
                    labelAlign: _vm.$config.forms.defaultLabelAlign,
                    id: _vm.formId
                  },
                  on: {
                    submit: function($event) {
                      return _vm.evh_1040167445267876_submit($event, {})
                    }
                  }
                },
                [
                  _c(
                    "ItpRow",
                    [
                      _c(
                        "ItpCol",
                        [
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "name",
                                label: _vm._f("pgettext")(
                                  "Name",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                ),
                                required: ""
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: { name: "name", required: "" },
                                model: {
                                  value: _vm.editor.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "name", $$v)
                                  },
                                  expression: "editor.name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "suspended",
                                label: _vm._f("pgettext")(
                                  "Suspended",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                )
                              }
                            },
                            [
                              _c("ItpFormCheckbox", {
                                attrs: { name: "suspended" },
                                model: {
                                  value: _vm.editor.suspended,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "suspended", $$v)
                                  },
                                  expression: "editor.suspended"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "notes",
                                label: _vm._f("pgettext")(
                                  "Notes",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                )
                              }
                            },
                            [
                              _c("ItpFormTextarea", {
                                attrs: { name: "notes" },
                                model: {
                                  value: _vm.editor.notes,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "notes", $$v)
                                  },
                                  expression: "editor.notes"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "function_name",
                                label: _vm._f("pgettext")(
                                  "Function",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                ),
                                required: ""
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: { name: "function_name", required: "" },
                                model: {
                                  value: _vm.editor.function_name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "function_name", $$v)
                                  },
                                  expression: "editor.function_name"
                                }
                              }),
                              _vm._v(" "),
                              _vm.resource.function_resolve_error
                                ? _c(
                                    "ItpAlert",
                                    {
                                      staticClass: "mt-3",
                                      attrs: {
                                        slot: "description",
                                        show: "",
                                        type: "warning"
                                      },
                                      slot: "description"
                                    },
                                    [
                                      _c(
                                        "p",
                                        [
                                          _c("ItpIcon", {
                                            attrs: { fa: "exclamation-circle" }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "ItpText",
                                            { attrs: { wrap: "" } },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.resource
                                                      .function_resolve_error
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "crontab_trigger",
                                label: _vm._f("pgettext")(
                                  "Cron Tab Entry",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                )
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: { name: "crontab_trigger" },
                                model: {
                                  value: _vm.editor.crontab_trigger,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "crontab_trigger", $$v)
                                  },
                                  expression: "editor.crontab_trigger"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "3",
                                name: "jitter",
                                label: _vm._f("pgettext")(
                                  "Jitter",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                )
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: { type: "number", name: "jitter" },
                                model: {
                                  value: _vm.editor.jitter,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editor, "jitter", $$v)
                                  },
                                  expression: "editor.jitter"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                labelColsMd: "3",
                                contentColsMd: "9",
                                name: "kwargs",
                                label: _vm._f("pgettext")(
                                  "Parameters",
                                  "NAVOnlineInvoiceInterfaceSettings"
                                )
                              }
                            },
                            [
                              _c("CodeMirror", {
                                staticClass: "border",
                                attrs: {
                                  mode: "json",
                                  options: _vm.b_7756430993412511_options
                                },
                                model: {
                                  value: _vm.kwargs,
                                  callback: function($$v) {
                                    _vm.kwargs = $$v
                                  },
                                  expression: "kwargs"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcFooter",
            {
              attrs: { slot: "footer", card: !_vm.modal, modal: _vm.modal },
              slot: "footer"
            },
            [
              _c("ItpButton", {
                staticClass: "mr-auto",
                attrs: {
                  text: _vm._f("pgettext")("Delete", "Button"),
                  variant: "danger",
                  icon: "fa-times",
                  spinning: _vm.actions.delete.isRunning
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.evh_1548630417156826_clickPreventStop($event, {})
                  }
                }
              }),
              _vm._v(" "),
              _c("ItpButton", {
                attrs: {
                  form: _vm.forms[_vm.formName] && _vm.forms[_vm.formName].id,
                  text: _vm._f("pgettext")("Save", "Button"),
                  type: "submit",
                  variant: "primary",
                  default: "",
                  spinning: _vm.actions.submit && _vm.actions.submit.isRunning
                }
              }),
              _vm._v(" "),
              _c("ItpButton", {
                attrs: {
                  text: _vm._f("pgettext")("Close", "Button"),
                  variant: "default",
                  disabled: _vm.actions.submit && _vm.actions.submit.isRunning
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.evh_2186679009640457_clickPreventStop($event, {})
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }